import { environment } from 'src/environments/environment';

export const apiUrl = environment.production
    ? `${ window.location.protocol }//${ window.location.hostname }:${ window.location.port }`
    : `${ window.location.protocol }//${ window.location.hostname }:4210`;
